export interface Category {
    id: number;
    name: string;
    disabled: boolean;
}

export interface PdfDocument {
    id: number;
    name: string;
    categoryName: string
}

export interface UploadDocumentResponse {
    documentId: number
}

export enum UserRole {
    SYSTEM_ADMIN = "SYSTEM_ADMIN",
    USER = "USER"
}

export interface User {
    userId?: number;
    id?: number;
    email: string;
    createdAt: string;
    role: UserRole;
    activated: boolean;
    position: string | null;
    phoneNumber: string | null;
}

export interface DataSourcePermission {
    groupId: number;
    permissionType: "READ_ONLY" | "EDIT";
}

export interface DataSourcePermissionQueryResult {
    groupId: number;
    name: string;
    permission: "READ_ONLY" | "EDIT";
}

export interface GroupQueryResult {
    id: number;
    name: string;
}

export interface DataSource {
    id: number;
    name: string;
    lastModificationDate: string;
    amountOfDocuments: number;
    owner?: {
        email?: string;
    };
    collectionType: string
}

export interface DocumentInDataSource {
    id: number,
    name: string;
    createdAt: string;
    extension: string,
    size: number;
    owner?: {
        email?: string;
    };
    conversationId?: number;
}

export interface ConversationResponse {
    id: number;
    title: string;
    createdAt: string;
    pinned?: boolean;
    pinOrder?: number | null;
}

export interface DocumentProps {
    documentId: number;
    documentName: string;
}

export interface MessageResponse {
    author: "USER" | "ASSISTANT";
    content: string;
    timestamp: string;
    documents?: DocumentProps[];
    contentSource?: string;
}

export interface ConversationHistoryResponse {
    messages: MessageResponse[];
    conversationDataSources: DataSource[];
}

export interface Citation {
    documentId: number;
    content: string;
}

export interface Message {
    author: string;
    id?: string;
    text: string;
    streamingText?: string;
    isSystem: boolean;
    isLoading?: boolean;
    isError?: boolean;
    documents?: DocumentProps[];
    citations?: Citation[];
    timestamp?: string;
}

export interface AssistantVariant {
    id: number;
    timestamp: string;
    content: string;
    active: boolean;
    documents?: DocumentProps[];
    citations?: Citation[];
}

export interface Model {
    id: number;
    displayName: string;
    description: string;
    isDefault: boolean;
}

export interface AuditLogEntry {
    timestamp: string;
    username: string;
    action: string;
    entityType: string;
    entityId: string;
    details: string;
}

export interface PagedResult<T> {
    content: T[];
    page: number;
    size: number;
    totalElements: number;
}

export type LogType = "AUDIT" | "TECHNICAL";

export interface LogQuery {
    from?: string;
    to?: string;
    page?: number;
    size?: number;
}
